class Tab {
  constructor(navElement, contentElement) {
    this.navElement = jQuery(navElement);
    this.contentElement = jQuery(contentElement);
    this.id = this.navElement.attr("id");

    this._isDisabled = false;
    this._isSelected = this.navElement.is(":checked");
    this._hasNeedyContent = this._checkForNeedyContent();

    this.navElement.on("change", () => {
      this._checkChange();
    });
  }

  // Getters/Setters

  get disabled() {
    return this._isDisabled;
  }

  set disabled(state) {
    state = Boolean(state);
    if (this._isDisabled == state) {
      return;
    }
    this.navElement.toggleClass("tab--disabled", state);
    this._isDisabled = state;
  }

  get selected() {
    this._isSelected = this.navElement.is(":checked");
    return this._isSelected;
  }

  get isNeedy() {
    return this._hasNeedyContent;
  }

  // Helpers
  _checkChange() {
    if (!this._isSelected && this.navElement.prop("checked", true)) {
      this.navElement.trigger("tab:selected");
    }
  }

  hide() {
    this.contentElement.hide().trigger("tab:hidden");
  }

  show(triggerChange) {
    this.contentElement.show().trigger("tab:shown", [this]);
    if (triggerChange) {
      this.navElement.prop("checked", true);
      this.navElement.trigger("change");
    }
  }

  // Private

  _checkForNeedyContent() {
    return this.contentElement.find('[data-behaviour~="needy-content"]').length;
  }
}

window.Tab = Tab;
